// extracted by mini-css-extract-plugin
export default {"fancyDiv":"Lu7q5___EmptyState-module__fancyDiv"};